import {
	Button, Card, Empty, Pagination, Table
}from "antd"
import React, {
	useEffect, useState
}from "react"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	appealsCollectiveActions
}from "../CollectiveAppeal/store/actions"
import "antd/lib/table/style/index.css"

// import "antd/lib/pagination/style/index.css";
import "../../../pagination.css"
import ConvertDBAddressToString from "../../../helpers/convertDBAddressToString"

const columns = [
	{
		title     : "№",
		dataIndex : "index",
		key       : "index"
	},
	{
		title     : "ФИО",
		dataIndex : "fio",
		key       : "fio"
	},
	{
		title     : "Email",
		dataIndex : "email",
		key       : "email"
	},
	{
		title     : "Адрес",
		dataIndex : "address",
		key       : "address"
	}
]

const ApplicantList = (props) => {
	const dispatch = useDispatch()
	const { applicants, applicantsOrg } = useSelector((state) => state.collectiveAppealReducer)
	const isRu = useSelector((state) => state.globalReducer.isRu)

	const [data, setData] = useState(null)
	const [page, setPage] = useState(1)
	const { AppealId, i18n } = props

	useEffect(() => {
		dispatch(appealsCollectiveActions.GetApplicants({
			AppealId : AppealId,
			Page     : 0,
			PageSize : 10
		}))
	}, [])

	useEffect(() => {
		if (applicants){
			if (applicants.count === 0){
				dispatch(appealsCollectiveActions.GetOrgApplicants({
					AppealId : AppealId,
					Page     : 0,
					PageSize : 10
				}))
			}
			fillData(applicants.items)
		}
	}, [applicants, isRu])

	useEffect(() => {
		if (applicantsOrg)
			fillData(applicantsOrg.items)
	}, [applicantsOrg, isRu])

	function fillData(items){
		const data = []
		items.forEach((val, index) => {
			data.push({
				key   : index + 1,
				index : (page - 1) * 10 + index + 1,
				fio   : `${ val.applicantLastName } ${ val.applicantFirstName }${
					val.applicantMiddleName != null ? ` ${ val.applicantMiddleName }` : ""
				}`,
				email   : val.applicantEmail,
				address : ConvertDBAddressToString(val.address, isRu)
			})
		})
		setData(data)
	}

	function onPaginationChange(value){
		setPage(value)
		if (applicants.count){
			dispatch(appealsCollectiveActions.GetApplicants({
				AppealId : AppealId,
				Page     : value - 1,
				PageSize : 10
			}))
		}
		else {
			dispatch(appealsCollectiveActions.GetOrgApplicants({
				AppealId : AppealId,
				Page     : value - 1,
				PageSize : 10
			}))
		}
	}

	return (
		<>
			{ data?.length ? (
				<>
					<Table
						columns={ columns }
						dataSource={ data }
						pagination={ false }
					/>
					{ applicants?.pageCount ? (
						applicants.pageCount > 1
					) : applicantsOrg?.pageCount > 1 ? (
						<Pagination
							current={ page }
							defaultCurrent={ 1 }
							pageSize={ 10 }
							showSizeChanger={ false }
							style={ { marginTop    : "1%",
								marginBottom : "3%" } }
							total={ applicants?.count ? applicants.count : applicantsOrg?.count }
							onChange={ onPaginationChange }
						/>
					) : null }
				</>
			) : null }
		</>
	)
}

export default ApplicantList
